import styled from "styled-components";
import { WidgetCardsContainer } from "../../../../components";
import { media } from "../../../../utils";

export const CardsContainer = styled(WidgetCardsContainer)`
  display: none;

  ${media.md()} {
    display: flex;
    justify-content: space-between;
    > div {
      width: 46%;
      max-width: none;
    }
  }
`;

export const RowBodyCard = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 14px 0;
  color: black;

  img {
    margin-top: 4px;
  }

  * {
    margin: 0 4px;
  }
`;

export const SwitchContentMobile = styled.div`
  ${media.md()} {
    display: none !important;
  }
`;
